import { all, fork } from "redux-saga/effects";
import ForgetSaga from "./auth/forgetpwd/saga";
import AuthSaga from "./auth/login/saga";
import ProfileSaga from "./auth/profile/saga";
//public
import AccountSaga from "./auth/register/saga";
import businessEmailTemplatesSaga from "./business-email-templates/saga";
import dashboardSaga from "./dashboard/saga";
import dataFormatSaga from "./data-format/saga";
import errorInvoicesSaga from "./error-invoices/saga";
import VATManager from "./general-info/VAT-manager/saga";
import BusinessUnitSaga from "./general-info/business-unit-bk/saga";
import CurrencyManager from "./general-info/currency-manager/saga";
import customerInvoiceSaga from "./general-info/customer/saga";
import invoiceSymbolSaga from "./general-info/invoice-symbol/saga";
import PaymentMethodManager from "./general-info/payment-method-manager/saga";
import productInvoiceSaga from "./general-info/product/saga";
import userInvoiceSaga from "./general-info/user/saga";
import invoiceTemplateSaga from "./invoice-template/saga";
import issueInvoiceSaga from "./issue-invoice/saga";
import LayoutSaga from "./layout/saga";
import menuSaga from "./menu/saga";
import noticeTCTSaga from "./notice-from-TCT/saga";
import notificationManagementSaga from "./notification-management/saga";
// import userManagementSaga from "./user-management/saga";
import signMethodSaga from "./general-info/sign-method/saga";
import issueInvoicePosSaga from "./invoice-pos/saga";
import PortalSaga from "./portal/saga";
import retrySaga from "./retry-action/saga";
import summaryInvoiceDataSaga from "./summary-invoice-data/saga";

export default function* rootSaga() {
  yield all([
    //public
    fork(AccountSaga),
    fork(AuthSaga),
    fork(ForgetSaga),
    fork(ProfileSaga),
    fork(LayoutSaga),
    fork(notificationManagementSaga),
    fork(BusinessUnitSaga),
    fork(VATManager),
    fork(CurrencyManager),
    fork(PaymentMethodManager),
    fork(menuSaga),
    fork(dataFormatSaga),
    fork(noticeTCTSaga),
    fork(issueInvoiceSaga),
    fork(issueInvoicePosSaga),
    fork(dashboardSaga),
    fork(PortalSaga),
    fork(errorInvoicesSaga),
    fork(summaryInvoiceDataSaga),
    fork(invoiceSymbolSaga),
    fork(productInvoiceSaga),
    fork(signMethodSaga),
    fork(customerInvoiceSaga),
    fork(userInvoiceSaga),
    fork(invoiceTemplateSaga),
    fork(businessEmailTemplatesSaga),
    fork(retrySaga),
  ]);
}
